/***************************************************************
8/7/2017
Alexander Self
Line chart
- Creates linechart for a set of data
***************************************************************/
import Chart from 'chart.js';


export function LineChart(ctx, labels, data, opts={}) {
  return new Chart(ctx, {
      type: 'line',
      data: {
          labels: labels,
          datasets: [{
              label: '',//label,
              data: data,
              backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)'
              ],
              borderColor: [
                  'rgba(255,99,132,1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)'
              ],
              borderWidth: 1
          }]
      },
      options: opts
  });
}

export function StackedChart(ctx, labels, data1, data2, yLength, title) {
  var opts = {
    responsive: true,
    hoverMode: 'index',
    stacked: false,
    title: {
      display: true,
      text: title
    },
    scales: {
      xAxes: [{
				scaleLabel: {
					display: true,
					labelString: 'Dates'
				}
			}],
      yAxes: [{
        type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: "left",
        id: "y-axis-1",
        ticks: {
          beginAtZero: true,
          suggestedMax: yLength
        },
        scaleLabel: {
					display: true,
					labelString: 'Total Employees'
				}
      },
      {
        type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: false,
        position: "right",
        id: "y-axis-2",
        // grid line settings
        ticks: {
          beginAtZero: true,
          suggestedMax: yLength
        },
        gridLines: {
          color: "rgba(0, 0, 0, 0)"
        }
    }]
    }
  };
  return new Chart.Line(ctx, {
      data: {
          labels: labels,
          datasets: [
            {
              label: 'Present',//label,
              backgroundColor: ['rgba(255, 99, 132, 0.2)'],
              borderColor: ['rgba(255,99,132,1)'],
              borderWidth: 1,
              fill: true,
              data: data1,
              yAxisID: "y-axis-1",
            },
            {
              label: 'Absent',//label,
              backgroundColor: ['rgba(54, 162, 235, 0.2)'],
              borderColor: ['rgba(54, 162, 235, 1)'],
              borderWidth: 1,
              data: data2,
              yAxisID: "y-axis-2",
            }
        ]
      },
      options: opts
  });
}

export function StackedBarChartWithLine(ctx, labels, data1, data2, data3, label1, label2, label3) {
  return new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: label1,
            backgroundColor: 'rgba(54, 162, 235, 1)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 2,
            fill: false,
            data: data1,
            yAxisID: "y-axis-2"
          },
          {
            type: 'bar',
            label: label2,
            backgroundColor: 'rgba(75, 192, 192, 1)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
            data: data2
          },
          {
            type: 'bar',
            label: label3,
            backgroundColor: 'rgba(255, 206, 86, 1)',
            borderColor: 'rgba(255, 206, 86, 1)',
            borderWidth: 2,
            data: data3,
            yAxisID: "y-axis-1"
          },
        ]
      },
      options: {
        responsive: true,
				title:{
					text: ''
				},
				tooltips: {
					mode: 'index',
				},
				hover: {
					mode: 'index'
				},
				scales: {
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Field'
						}
					}],
					yAxes: [{
						stacked: false,
            position: "left",
            scaleLabel: {
							display: true,
							labelString: 'Count'
						},
            id: "y-axis-1",
            ticks: {
              beginAtZero:true
            }
					},
          {
						stacked: false,
            position: "left",
            scaleLabel: {
							display: true,
							labelString: 'Bag & Tree Count'
						},
            id: "y-axis-1"

					},
          {
            type: "linear",
            display: true,
            position: "right",
            scaleLabel: {
							display: true,
							labelString: 'Density'
						},
            gridLines: {
              color: "rgba(0, 0, 0, 0)"
            },ticks: {
              beginAtZero:true
            },
            id: "y-axis-2"
          }
        ]
				}
      }
  });
}

export function StackedBarChart(ctx, labels, data1, data2, label1, label2) {
  return new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'bar',
            label: label1,
            backgroundColor: 'rgba(75, 192, 192, 1)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
            data: data1
          },
          {
            type: 'bar',
            label: label2,
            backgroundColor: 'rgba(255, 206, 86, 1)',
            borderColor: 'rgba(255, 206, 86, 1)',
            borderWidth: 2,
            data: data2,
            yAxisID: "y-axis-1"
          },
        ]
      },
      options: {
        responsive: true,
				title:{
					text: ''
				},
				tooltips: {
					mode: 'index',
				},
				hover: {
					mode: 'index'
				},
				scales: {
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Department'
						}
					}],
					yAxes: [{
						stacked: false,
            position: "left",
            scaleLabel: {
							display: true,
							labelString: 'Hours'
						},
            id: "y-axis-1",
            ticks: {
              beginAtZero:true
            }
					}]
				}
      }
  });
}

export function BarChart(ctx, labels, data, title, label) {
  return new Chart(ctx, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: [{
              label,
              data: data,
              backgroundColor: data.map((d) => `rgba(${Math.floor(Math.random()*300)}, ${Math.floor(Math.random()*100)}, ${Math.floor(Math.random()*200)}, 0.2)`),
              borderColor:data.map((d) => `rgba(${Math.floor(Math.random()*300)}, ${Math.floor(Math.random()*100)}, ${Math.floor(Math.random()*200)}, 1`),
              borderWidth: 1
          }]
      },
      options: {
        responsive: true,
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: title
        },
        scales: {
    			xAxes: [{
    				scaleLabel: {
    					display: true,
    					labelString: 'Fields'
    				}
    			}],
    			yAxes: [{
    				stacked: true,
    				scaleLabel: {
    					display: true,
    					labelString: 'Hours'
    				}
    			}]
    		}
    }
  });
}







/* END */



// WEBPACK FOOTER //
// ./src/components/charts/misc_chart.js